/* eslint-disable @typescript-eslint/no-unused-vars */
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import React from "react";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";
import { GenericTag } from "@ui-components/Tag/GenericTag";

export interface Datacenter {
	datacenterId: string;
	name: string;
	displayName: string;
	direction: string;
	gps: string;
	capacityKW: string;
	phase: string;
	cage: string;
	rackId: string;
	rackCapacity: string;
	patchPanelODF: string;
	rackSecurityPin: string;
	status: string;
	visible: boolean;
	providerCode: string;
	city: string;
	providerId: number;
	createdAt: string;
	updatedAt: string;
	provider: {
		id: number;
		name: string;
		idAddon: string;
		createdAt: string;
		updatedAt: string;
	};
	hardwareResources?: Array<{
		id: number;
		hostname: string;
	}>;
	hardwareCount?: number;
	numberOfHardware?: number; // Keep for backward compatibility
	influxKeys?: Array<{
		id: number;
		keyInflux: string;
		isActive: boolean;
	}>;
}

export const columns: GenericTableColumn<Datacenter>[] = [
	{
		header: "Datacenter ID",
		accessor: "datacenterId",
	},
	{
		header: "Name",
		accessor: "name",
	},
	{
		header: "Address",
		accessor: "direction",
		renderCell: (row: Datacenter) => (
			<div className="max-w-[200px] overflow-x-auto thin-scroll" style={{ maxWidth: "200px" }}>
				<span className="whitespace-nowrap inline-block">{row.direction || "-"}</span>
			</div>
		),
	},
	{
		header: "Provider",
		renderCell: (row: Datacenter) => {
			return row.provider?.name || "-";
		},
	},
	{
		header: "Status",
		renderCell: (row: Datacenter) => {
			const variant = row.status === "Active" ? "neutral" : "default";
			return (
				<GenericTag
					variant={variant}
					label={row.status || "-"}
					size="small"
				/>
			);
		},
	},
	{
		header: "Number of Hardware",
		renderCell: (row: Datacenter) => {
			return row.hardwareCount ?? 0;
		},
	},
	{
		header: "Actions",
		accessor: "datacenterId",
		renderCell: (row) => (
			<div className="flex items-center gap-2">
				{/* Actions will be overridden in DatacenterPage.tsx */}
			</div>
		),
	},
];
